import React, { useEffect, useState } from "react";

export default function NewCartButton(props) {
    const fullParent = props.elem?.dataset?.full ? Boolean(props.elem.dataset.full) : props.full;
    const onlyIcon = props.elem?.dataset?.onlyIcon ? Boolean(props.elem.dataset.onlyIcon) : false;
    let ID = props.elem?.dataset?.id ? Number(props.elem.dataset.id) : props.id;
    let propsSelected = props.elem?.dataset?.selected
        ? props.elem.dataset.selected
        : props.selected;
    let propsOwned = props.elem?.dataset?.owned ? Boolean(props.elem.dataset.owned) : props.owned;
    // singleButton is for showing only cart icon and used in the Search Result
    let singleButton = props.elem?.dataset?.singleButton
        ? Boolean(props.elem.dataset.singleButton)
        : props.singleButton;

    let loggedin = window.Dibook.loggedin ?? false;

    const altIcon = props.elem?.dataset?.altIcon
        ? props.elem?.dataset?.altIcon === "true"
        : props.altIcon;

    let multipleIds = props.elem?.dataset?.multipleid || props.multipleid;
    if (multipleIds !== undefined && typeof multipleIds === "string")
        multipleIds = JSON.parse(multipleIds);

    let [selected, setSelected] = useState(propsSelected);
    let [loading, setLoading] = useState(true);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        // Fetching cart
        window.Dibook.cart
            .fetchCart()
            .then((payload) => {
                setLoading(false);

                let cart = payload.content?.data?.cart;

                if (multipleIds !== undefined)
                    setSelected(multipleIds.every((id) => itemInCart(id, cart)));
                else setSelected(itemInCart(ID, cart));

                setAnimate(false);
            })
            .catch((error) => console.log(error));

        let addingSubId = window.Dibook.cart.on("itemsAdding", (payload) => {
            if (payload.includes(ID)) setLoading(true);
        });

        let addedSubId = window.Dibook.cart.on("itemsAdded", (payload) => {
            setLoading(false);
            let cart = payload.content?.data?.cart;

            if (multipleIds !== undefined)
                setSelected(multipleIds.every((id) => itemInCart(id, cart)));
            else setSelected(itemInCart(ID, cart));

            if (payload.status === 403) showLogin();
        });

        let removingSubId = window.Dibook.cart.on("itemsRemoving", (payload) => {
            if (payload.includes(ID)) setLoading(true);
        });

        let removedSubId = window.Dibook.cart.on("itemsRemoved", (payload) => {
            setLoading(false);
            let cart = payload.content?.data?.cart;

            if (multipleIds !== undefined)
                setSelected(multipleIds.every((id) => itemInCart(id, cart)));
            else setSelected(itemInCart(ID, cart));

            if (payload.status === 403) showLogin();
        });

        return () => {
            window.Dibook.cart.off("itemsAdding", addingSubId);
            window.Dibook.cart.off("itemsAdded", addedSubId);
            window.Dibook.cart.off("itemsRemoving", removingSubId);
            window.Dibook.cart.off("itemsRemoved", removedSubId);
        };
    }, [ID, multipleIds]);

    const className = `label ${props.layout === "compact" ? "compact" : ""}`;

    return (
        <div className="new-widget-cartbutton-component">
            <div
                className={
                    "cartbutton " +
                    (selected ? ` clicked cartbutton--selected` : "") +
                    (propsOwned ? " cartbutton--owned" : "") +
                    (loading ? " cartbutton--loading" : "") +
                    (singleButton ? " cartbutton--single" : "") +
                    (animate && !onlyIcon ? " animate" : "")
                }
            >
                <button
                    className={"new-cart-btn "+(loading && (!animate || onlyIcon) ? " loading-spin" : "")}
                    data-selected={selected}
                    data-owned={propsOwned || undefined}
                    style={{
                        width: fullParent && "100%",
                    }}
                    onClick={() => handleCartButtonClick()}
                >
                    {onlyIcon ? (
                        <>
                            {!propsOwned &&
                            <>
                                {selected ? 
                                <img src="/images/icon/cart-full-white.svg" alt="Kosár icon" /> :
                                <img src="/images/icon/cart.svg" alt="Kosár icon" />}
                            </>}
                        </>
                    ) : (
                        <>
                            <p className="m-0 add-to-cart">
                                {propsOwned ? "Már megvetted" : selected ? "Kosárban" : "Kosárba"}
                            </p>

                            {!propsOwned && (
                                <div className="add-to-cart">
                                    {selected ? (
                                        altIcon ? (
                                            <div>
                                                <i className="fa-solid fa-cart-shopping"></i>
                                            </div>
                                        ) : (
                                            <img
                                                src="/images/icon/cart-full-white.svg"
                                                alt="Kosár icon"
                                            />
                                        )
                                    ) : altIcon ? (
                                        <img src="/images/icon/cart.svg" alt="Kosár icon" />
                                    ) : (
                                        <img src="/images/icon/cart.svg" alt="Kosár icon" />
                                    )}
                                </div>
                            )}
                            <div className="cartIcon">
                                <i className="fa-solid fa-cart-shopping"></i>
                            </div>
                            <div className="cartBox">
                                <i className="fa-solid fa-box"></i>
                            </div>
                        </>
                    )}
                </button>
            </div>
        </div>
    );

    function handleCartButtonClick() {
        if (loading) return;
        if (!loggedin && props.forceLogin) return showLogin();

        if (selected) {
            setAnimate(false);
            window.Dibook.cart.removeItems([ID]);
            return;
        };
        if (propsOwned)
            return (location.href =
                props.bookType === "audio" ? "/profil/hangoskonyv" : "/profil/ebook");

        if (multipleIds !== undefined) {
            const cart = window.Dibook?.cart?.cart?.data?.cart || [];
            const notInCart = multipleIds.filter((id) => !itemInCart(id, cart));
            window.Dibook.cart.addItems(notInCart);
        } else window.Dibook.cart.addItems([ID]);
        setAnimate(true);
    }

    function showLogin() {
        window.$("#loginModal").modal("show");
    }
}

export function itemInCart(itemId, cart) {
    if (!cart) return false;
    let filteredCartItems = cart.filter((item) => item.id === itemId);
    return filteredCartItems.length > 0;
}